// 자주사용문구 - 한국어
export const modalMsg = {
  update: {
    title: "저장하시겠어요?",
    content: (
      <>
        이전 데이터는 복구가 불가합니다.
        <br />
        저장을 진행하시겠어요??
      </>
    ),
  },
  delete: {
    title: "삭제하시겠어요?",
    content: (
      <>
        삭제된 데이터는 복구가 불가합니다.
        <br />
        그래도 삭제하시겠어요??
      </>
    ),
  },
  create: { title: "등록하시겠어요??" },
  approve: { title: "승인하시겠어요??" },
  activate: { title: "활성화하시겠어요??" },
  deactivate: { title: "비활성화하시겠어요??" },
};
